export const ACCESS_TOKEN_STORAGE_KEY = "ACCESS_TOKEN_STORAGE_KEY";
export const RECENT_ORDER_ID_STORAGE_KEY = "RECENT_ORDER_ID_STORAGE_KEY";
export const RECENT_VIEW_ID_STORAGE_KEY = "RECENT_VIEW_ID_STORAGE_KEY"